import React from 'react';
import connectLogo from "./assets/Logo.svg";

function Footer() {
    return (
        <div className={"pageFooter"}>
            <div className={"container"}>
                <div>
                    <img src={connectLogo} alt="Connect" className={"footerLogo"} />
                </div>
                <p className={"footerBrand"}>Thorne Harbour Health CONNECT</p>
                <p className={"footerPhone"}>
                    <a href="tel:+610870995300" style={{color: "inherit", textDecoration: "none"}}>+61 (8) 7099 5300</a>
                </p>
                <p className={"footerCopyright"}>Copyright &copy; Thorne Harbour Health. All rights reserved.</p>
            </div>
        </div>
    );
}

export default Footer;
